import { useEffect, useState } from "react";
import { onAuthStateChanged, getIdTokenResult } from "firebase/auth";
import { auth } from "./firebase";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const [loading, setLoading] = useState(true);
  const [ok, setOk] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) {
        setOk(false);
        setLoading(false);
        return;
      }
      if (!requireAdmin) {
        setOk(true);
        setLoading(false);
        return;
      }
      const t = await getIdTokenResult(u, true);
      const isAdmin = !!t.claims.admin;
      setOk(isAdmin);
      setLoading(false);
    });
    return () => unsub();
  }, [requireAdmin]);

  if (loading) return null;
  return ok ? children : <Navigate to="/login" replace />;
}
